exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".w-49{-ms-flex-preferred-size:49%;flex-basis:49%;max-width:49%}.margin-bootom{margin-bottom:1rem}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/agendamento/ScheduleModal/ScheduleDetails.vue"],"names":[],"mappings":"AACA,MACE,4BAA6B,AAC7B,eAAgB,AAChB,aAAe,CAChB,AACD,eACE,kBAAoB,CACrB","file":"ScheduleDetails.vue","sourcesContent":["\n.w-49{\n  -ms-flex-preferred-size: 49%;\n  flex-basis: 49%;\n  max-width: 49%;\n}\n.margin-bootom {\n  margin-bottom: 1rem;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9452970c","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/painel/agendamento/ScheduleModal/ScheduleDetails.vue
// module id = 472
// module chunks = 0 1